<template>
  <v-card class="elevation-0 transparent">
    <v-card-title
      primary-title 
      class="layout justify-center"
    >
      <div class="h_second_line">
        {{ $t('h_about_head_05') }}
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-container>
      <v-layout row wrap>
        <v-flex
          v-for="item in hobbyMap"
          :key="item.name"
          sm6
          md4
          lg4
        >
          <v-card flat class="text-xs-center ma-3 elevation-0 transparent">
            <v-card-title 
              primary-title 
              class="justify-center"
            >
              <v-icon 
                x-large 
                class="blue--text text--lighten-2"
              >
                {{item.icon}}
              </v-icon>
            </v-card-title>
            <v-card-actions class="justify-center">
              <h3 class="headline blue--text text--lighten-2">{{item.name}}</h3>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>    
  </v-card>
</template>

<script>
  export default {
    computed:{
      hobbyMap(){
        return this.$store.getters.getHM
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>